export const fieldArray = ["Booth Name","Booth Number","Page Number"]